import { render, staticRenderFns } from "./AddressImportForm.vue?vue&type=template&id=1bbbb5e2&"
import script from "./AddressImportForm.vue?vue&type=script&lang=js&"
export * from "./AddressImportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports